import axios from 'axios';

import { getEnv } from '../env';

import { apiClient } from './axios';

import type { Setting, UpdateSettingDto, BulkUpdateSettingsDto } from '@repo/shared-types';

export const settingsApi = {
  getSettings: async (category?: string) => {
    const params = category ? { category } : {};
    const response = await apiClient.get<Setting[]>('/settings', { params });
    return response.data;
  },

  getSetting: async (key: string) => {
    const response = await apiClient.get<Setting>(`/settings/${key}`);
    return response.data;
  },

  updateSetting: async (key: string, data: UpdateSettingDto) => {
    const response = await apiClient.patch<Setting>(`/settings/${key}`, data);
    return response.data;
  },

  bulkUpdateSettings: async (data: BulkUpdateSettingsDto) => {
    const response = await apiClient.patch<Setting[]>('/settings', data);
    return response.data;
  },

  /** Whether SETTINGS_ENCRYPTION_KEY is properly configured (valid 64-char hex). */
  getEncryptionStatus: async (): Promise<{ configured: boolean }> => {
    const response = await apiClient.get<{ configured: boolean }>('/settings/encryption-status');
    return response.data;
  },

  /** Public endpoint — no auth required */
  getBranding: async (): Promise<Record<string, string | null>> => {
    const baseUrl = getEnv('VITE_API_URL');
    const response = await axios.get<Record<string, string | null>>(`${baseUrl}/settings/branding`);
    return response.data;
  },

  /** Public endpoint — no auth required */
  getFeatures: async (): Promise<Record<string, boolean | string>> => {
    const baseUrl = getEnv('VITE_API_URL');
    const response = await axios.get<Record<string, boolean | string>>(
      `${baseUrl}/settings/features`,
    );
    return response.data;
  },
};
